import React from "react"
import { connect } from "react-redux";
import { setSearchWindowOpen } from "../Actions/SearchWindow.action";
import QuickSearchContainer from "../Containers/QuickSearch.container";
import { translate } from "../Services/translation";

const SearchWindow = props => {
    const { open, setIsOpen } = props

    React.useEffect(() => {
        if(open) {
            document.querySelector("body").classList.add("no-scroll")
        }else{
            document.querySelector("body").classList.remove("no-scroll")
        }
    }, [open])
    
    return open && <div className="search-window">
        <button className="search-window__close-btn" aria-label="Close search window" onClick={() => setIsOpen(false)}><i className="icon icon-cancel"></i></button>
        <div className="search-window__wrapper">
            <h2>{translate("search.title")}</h2>
            <QuickSearchContainer></QuickSearchContainer>
        </div>
    </div>
}

const mapStateToProps = state => {
    return {
        open: state.searchWindow.open,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setIsOpen: open => dispatch(setSearchWindowOpen(open)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchWindow);